// Where Keycloak sends the browser back after sign-in. The sign-in library
// (react-oidc-context's AuthProvider) reads the code and state from this
// address and exchanges them for tokens. Only once it has finished may the page
// move on: a redirect any sooner drops the code from the address before it is
// read, and nobody is signed in.
import { useAuth } from 'react-oidc-context';
import { Link, Navigate } from 'react-router';

import { useMistWebUrl } from '../app/config';
import { ErrorPanel, Loading, PageHeader } from '../design/components';
import { returnPathOf } from './session';

export function AuthCallback() {
    const auth = useAuth();
    const mistWeb = useMistWebUrl();
    if (auth.isLoading) {
        return (
            <main className="sf-page">
                <Loading what="your sign-in" />
            </main>
        );
    }
    if (auth.error) {
        return (
            <main className="sf-page sf-stack">
                <PageHeader title="Signing in didn’t work" />
                <ErrorPanel error={auth.error} title="Keycloak’s answer couldn’t be used." />
                <p>
                    <Link to="/floor">Back to the floor</Link>
                    {mistWeb ? (
                        <>
                            {' '}
                            or <a href={mistWeb}>back to MIST</a>
                        </>
                    ) : null}
                </p>
            </main>
        );
    }
    return <Navigate to={returnPathOf(auth.user?.state)} replace />;
}
